import { render, staticRenderFns } from "./WasteImageUploader.vue?vue&type=template&id=680ba626&scoped=true&"
import script from "./WasteImageUploader.vue?vue&type=script&lang=js&"
export * from "./WasteImageUploader.vue?vue&type=script&lang=js&"
import style0 from "./WasteImageUploader.vue?vue&type=style&index=0&id=680ba626&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680ba626",
  null
  
)

export default component.exports